module.exports = __webpack_public_path__ + "img/首页轮播图3.9b3f12f6.png";